import React from 'react';

import EpisodeCard from '../../components/episode-card/EpisodeCard';
import Spinner from '../../components/spinner/Spinner';
import PageTitle from '../../components/page-title/PageTitle';
import Categories from '../../components/categories/Categories';

import useFetch from '../../effects/useFetch.effect';
import { data } from './category-page-data';

import { PodcastContainer } from './CategoryPage.styles';

const CategoryPage = ({ match }) => {
  const { categoryId } = match.params;
  const { data, loading } = useFetch(
    `/.netlify/functions/listennotes?url=best_podcasts?genre_id=${categoryId}`
  );
  if (loading) return <Spinner />;
  const { name: title, podcasts } = data;

  return (
    <div>
      <PageTitle>Popular in {title}</PageTitle>
      <PodcastContainer>
        {podcasts.map(podcast => (
          <EpisodeCard key={podcast.id} podcast={podcast} />
        ))}
      </PodcastContainer>
      <Categories />
    </div>
  );
};

export default CategoryPage;
